import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "modal-flash-message",
  class: "modal-flash-message"
}

import { ref, watch} from "vue"

export interface Props {
  message: string
  show: boolean
  type: string
  cancel: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalFlashMessage',
  props: {
    message: { default: '' },
    show: { type: Boolean, default: false },
    type: { default: 'info' },
    cancel: { type: Boolean, default: false }
  },
  emits: ["setShow"],
  setup(__props: any, { emit: __emit }) {

const localShow = ref(false)

let timeId:number

const props = __props
const emit = __emit

const closeFlashMessage = () => {
  timeId = setTimeout(() => {
    localShow.value = false
    emit('setShow', false)
  }, 10000);
}
const cancelSetTimeOut = () => {
  clearTimeout(timeId);
}

watch(() => props.show, () => {
  localShow.value = props.show
  if (localShow.value) {
    closeFlashMessage()
  }
});
watch(() => props.cancel, () => {
  if (props.cancel) {
    cancelSetTimeOut()
  }
});


return (_ctx: any,_cache: any) => {
  return (localShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["pt-2 pb-2 pl-6", __props.type])
        }, _toDisplayString(__props.message), 3)
      ]))
    : _createCommentVNode("", true)
}
}

})